import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const INVENTORYTYPE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.InventoryType.Name')
    .required()
    .minLength(1)
    .maxLength(100)
    .build(),
  FieldBuilder
    .checkbox('isRealInventory', 'Entity.InventoryType.IsRealInventory')
    .build(),
];

export const INVENTORYTYPE_CONFIG = {
  entityName: 'InventoryType',
  localizationKey: 'Planning::Entity.InventoryType',
  fields: INVENTORYTYPE_FIELDS,
  permission: 'PlanningInventory.InventoryTypes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Inventory + MENU_NAME_SUFFIX,
};
